//examine
<template>
  <div class="link-views white-bg">
    <Table :columns="columns" :data="resultsObj.Result" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <div class="action-table">
          <a @click="showDetail(row)">查看详情</a>
          <span class="examine gray" v-if="row.State==1">(未审批)</span>
          <span class="examine green" v-if="row.State==2">(同意预约)</span>
          <span class="examine red" v-if="row.State==3">(拒绝预约)</span>
        </div>
      </template>
    </Table>
    <Modal
      v-model="showfullscreen"
      fullscreen
      title="预约详情"
      :class="{'myfullscreen':true,'noLeft':isCollapsed,'nofooter':AppointmentDetails.State!=1 }"
      :mask-closable="false"
    >
      <ul style="line-height:2.6; margin-left:50px;">
        <li>
          <strong>申请编号：</strong>
          <span>{{AppointmentDetails.AppointmentNo}}</span>
        </li>
        <li>
          <strong>申请人：</strong>
          <span>{{AppointmentDetails.UserName}}</span>
        </li>
        <li>
          <strong>联系方式：</strong>
          <span>{{AppointmentDetails.Telephone}}</span>
        </li>
        <li>
          <strong>申请实验室：</strong>
          <span>{{AppointmentDetails.RoomName}}</span>
        </li>
        <li>
          <strong>申请设备：</strong>
          <span>{{AppointmentDetails.Equipment}}</span>
        </li>
        <li>
          <strong>申请时间：</strong>
          <span>{{AppointmentDetails.TimeStart}}</span>
          &nbsp;&nbsp;
          <span>{{AppointmentDetails.TimeEnd}}</span>
        </li>
        <li>
          <strong>创建时间：</strong>
          <span>{{AppointmentDetails.CreateTime}}</span>
        </li>
        <li>
          <strong>申请原因：</strong>
          <span>{{AppointmentDetails.Describes}}</span>
        </li>
        <li class="red" v-if="AppointmentDetails.ErrReason&&AppointmentDetails.State==3">
          <strong>拒绝原因：</strong>
          <span>{{AppointmentDetails.ErrReason}}</span>
        </li>
      </ul>
      <div slot="footer">
        <Button type="primary" @click="agreement(2)">同意</Button>
        <Button type="primary" @click="agreement(3)">拒绝</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import * as homeApi from "../../../api/teacher-api.js";
export default {
  name: "examine",
  data() {
    return {
      loading: true,
      resultsObj: {},
      pageData: {
        page: 1,
        size: 10
      },
      columns: [
        {
          title: "申请编号",
          key: "AppointmentNo",
          align: "center"
        },
        {
          title: "申请人",
          key: "UserName",
          align: "center"
        },
        {
          title: "联系方式",
          key: "Telephone",
          align: "center"
        },
        {
          title: "申请实验室",
          key: "RoomName",
          align: "center"
        },
        {
          title: "申请日期",
          key: "TimeStart",
          align: "center"
        },
        {
          title: "申请时间段",
          key: "TimeEnd",
          align: "center"
        },
        {
          title: "可选操作",
          slot: "action",
          align: "center"
        }
      ],
      showfullscreen: false,
      AppointmentDetails: {},
      examineObj: {
        AppointmentId: null,
        State: null,
        ErrReason: ""
      }
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.isCollapsed;
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    //获取分页数据
    async getDataList() {
      this.resultsObj = await homeApi.GetAppointmentList({
        page: this.pageData.page ? this.pageData.page : 1,
        size: this.pageData.size ? this.pageData.size : 10
      });
      this.loading = false;
    },
    // 显示详情
    showDetail(row) {
      this.examineObj.AppointmentId = row.AppointmentId;
      homeApi
        .GetAppointmentById({
          AppointmentId: row.AppointmentId
        })
        .then(res => {
          this.AppointmentDetails = res;
          this.showfullscreen = true;
        });
    },
    //
    examine() {
      homeApi.examine(this.examineObj).then(res => {
        this.$Message.success({
          content: res.msg,
          duration: 3
        });
        this.showfullscreen = false;
        this.getDataList();
      });
    },
    //同意或拒绝
    agreement(number) {
      this.examineObj.State = number;
      if (number == 2) {
        this.examineObj.ErrReason = "";
        this.$Modal.confirm({
          title: "同意预约",
          onOk: () => {
            this.examine();
          }
        });
      } else {
        this.$Modal.confirm({
          title: "拒绝预约",
          render: h => {
            return h("Input", {
              props: {
                value: this.examineObj.ErrReason,
                autofocus: true,
                placeholder: "请填写拒绝理由"
              },
              on: {
                input: val => {
                  this.examineObj.ErrReason = val;
                }
              }
            });
          },
          onOk: () => {
            if (this.examineObj.ErrReason) {
              this.examine();
            } else {
              this.$Message.error({
                content: "请填写拒绝理由",
                duration: 3
              });
            }
          }
        });
      }
    },
  }
};
</script>

<style scoped>
</style>